import React, { PropTypes } from 'react';
import classnames from 'classnames';

export default class LayoutItem extends React.Component {
  static propTypes = {
    weight: PropTypes.number,
    grow: PropTypes.bool,
    hide: PropTypes.string,
    children: PropTypes.node,
    full: PropTypes.bool,
  };

  render() {
    const { weight, grow, hide, children, full } = this.props;

    const styles = {
      wrapper: classnames({
        'layout--item': true,
        'layout--item--weight-one': weight === 1,
        'layout--item--weight-two': weight === 2,
        'layout--item--weight-three': weight === 3,
        'layout--item--grow': grow,
        'layout--item--hide-under-wide-screen': hide === 'under-wide-screens',
        'layout--item--hide-wide-screen': hide === 'wide-screens',
        'layout--item--full': full,
      }),
    };

    return (
      <div className={styles.wrapper}>
        {children}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/Layout/LayoutItem.jsx
 **/